import { rightDirectory } from "@shared/scripts/utils/tool";

const topic = () => {
  rightDirectory("#js-article-content", "h2");
};

export default topic;
